import React from 'react';
import { Slider as BaseSlider } from 'antd';
import { SliderRangeProps, SliderSingleProps } from 'antd/lib/slider';

type IProps = SliderSingleProps | SliderRangeProps;

const Slider = (props: IProps) => <BaseSlider {...props} />;

export default Slider;
